export type NinSlipTypeId =
  | 'regular_slip'
  | 'standard_slip'
  | 'premium_slip'
  | 'advanced_slip';

export const NIN_SLIP_FEATURES: Record<NinSlipTypeId, string[]> = {
  regular_slip: ['NIN Number', 'Full Name', 'Gender', 'Photo', 'Address', 'Tracking ID'],
  standard_slip: ['NIN Number', 'Full Name', 'Gender', 'Date of Birth', 'Photo'],
  premium_slip: ['NIN Number', 'Full Name', 'Gender', 'Date of Birth', 'Photo'],
  advanced_slip: [
    'NIN Number',
    'Full Name',
    'Gender',
    'Date of Birth',
    'Birth Location (LGA & State)',
    'Residence Address',
    'Residence Location (LGA, State & Town)',
    'Tracking ID',
    'Photo',
  ],
};

export const NIN_SLIP_DESCRIPTIONS: Record<NinSlipTypeId, string> = {
  regular_slip: 'Basic identity details with address',
  standard_slip: 'Standard details including date of birth',
  premium_slip: 'Premium slip with photo and birth information',
  advanced_slip: 'Full demographic and residence details',
};

export const NIN_SLIP_LABELS: Record<NinSlipTypeId, string> = {
  regular_slip: 'Regular NIN',
  standard_slip: 'Standard NIN',
  premium_slip: 'Premium NIN',
  advanced_slip: 'Advanced NIN',
};

export const NIN_SLIP_SAMPLE_IMAGES: Record<NinSlipTypeId, string> = {
  regular_slip: '/verification/regular-sample.png',
  standard_slip: '/verification/standard-sample.png',
  premium_slip: '/verification/premium-sample.png',
  advanced_slip: '/verification/advanced-sample.jpg',
};

export const SLIP_ROUTE_MAP: Record<NinSlipTypeId, string> = {
  regular_slip: 'regular',
  standard_slip: 'standard',
  premium_slip: 'premium',
  advanced_slip: 'advanced',
};

export const SLIP_TYPE_FROM_ROUTE: Record<string, NinSlipTypeId> = {
  regular: 'regular_slip',
  standard: 'standard_slip',
  premium: 'premium_slip',
  advanced: 'advanced_slip',
};
